// Helpers extracted from invoices/index.tsx to keep the grandfathered route
// under its existing line count when adding the RouteShell wrapper.
// The hyphen prefix tells TanStack Router this is a private module, not a route.

export type PageItem =
	| { type: "page"; page: number; key: string }
	| { type: "ellipsis"; key: string; page: 0 };

export function buildPageNumbers(current: number, total: number): PageItem[] {
	const pages = Array.from({ length: total }, (_, i) => i + 1).filter(
		(p) => p === 1 || p === total || Math.abs(p - current) <= 1,
	);
	const items: PageItem[] = [];
	let prev = 0;
	for (const p of pages) {
		if (p - prev > 1) {
			items.push({ type: "ellipsis", key: `ellipsis-after-${prev}`, page: 0 });
		}
		items.push({ type: "page", page: p, key: `page-${p}` });
		prev = p;
	}
	return items;
}

// When selection is mixed, disabled buttons keep the base label but append
// the eligible subset count — so the user can see at a glance how many of
// their picks would actually be acted on, and where the gap is. Labels stay
// clean when the selection is fully eligible or fully ineligible.
export function bulkActionLabel(
	base: string,
	eligible: number,
	total: number,
	noun: string,
): string {
	if (eligible === total) return base;
	if (eligible === 0) return base;
	return `${base} ${eligible} ${noun}${eligible === 1 ? "" : "s"}`;
}

export function draftActionTooltip(draftCount: number, total: number): string | undefined {
	if (draftCount === total) return undefined;
	if (draftCount === 0) return "No drafts in selection";
	return `${draftCount} of ${total} selected are drafts. Filter to 'Draft' status to enable.`;
}

export function pushActionTooltip(pushableCount: number, total: number): string | undefined {
	if (pushableCount === total) return undefined;
	if (pushableCount === 0) return "No approved invoices in selection";
	return `${pushableCount} of ${total} selected are approved and unpushed. Filter to 'Approved' status to enable.`;
}
